import { States } from "../../../common/constants/states";
import { isJson } from "../../../common/helpers/json";

class AdhocPickupLocations {
  constructor(
    $rootScope,
    $state,
    $stateParams,
    SchoolsModel,
    UsersModel,
    FlashService,
    UserService,
    PoliciesModel,
    PolicyData,
  ) {
    this.loading = true;
    this.busy = true;
    this.currentUser = UserService.getCurrentUser();
    this.$rootScope = $rootScope;
    this.$state = $state;
    this.UsersModel = UsersModel;
    this.PoliciesModel = PoliciesModel;
    this.SchoolsModel = SchoolsModel;
    this.FlashService = FlashService;
    this.states = States;

    this.hasPickupLocation = false;
    this.pickuplocations = [];
    this.pickuplocation = {};
    this.submitted = false;
    this.currentPage = 1;
    this.per_page = 15;
    this.totalItems = 0;

    this.PolicyData = PolicyData;
    this.allow_adhoc_pickup_locations = PolicyData.FeatureEnabled;

    // TODO: This is probably not necessary; the addres is probably already
    // an object
    this.parseAddressJson = this.parseAddressJson.bind(this);

    this.fetchLocations();

    $rootScope.$on("ADHOC_PICKUP_LOCATION_CREATED", () => {
      this.fetchLocations();
    });
  }

  updateSetting() {
    this.busy = true;
    this.PoliciesModel.update({
      id: this.PolicyData.id,
      allow_adhoc_pickup_locations: this.allow_adhoc_pickup_locations
        ? "Y"
        : "N",
    })
      .then((response) => {
        this.FlashService.setMessage({
          type: "success",
          message: response.message,
        });
        this.busy = false;
      })
      .catch((error) => {
        this.busy = false;
      });
  }

  fetchLocations() {
    this.busy = true;
    this.SchoolsModel.getAdhocPickupLocations(this.currentUser.school_id, {
      paginate: true,
      page: this.currentPage,
      per_page: this.per_page,
    })
      .then((response) => {
        this.pickuplocations = response.pickuplocations.data.map(
          this.parseAddressJson,
        );
        this.totalItems = response.pickuplocations.total;
        this.loading = false;
        this.busy = false;
      })
      .catch(() => {
        this.busy = false;
        this.loading = false;
      });
  }

  pageChanged() {
    this.fetchLocations();
  }

  parseAddressJson(location) {
    location.address = isJson(location.address)
      ? JSON.parse(location.address)
      : location.address;
    return location;
  }

  removePickupLocation(id) {
    this.busy = true;

    this.SchoolsModel.removeAddhocPickupLocation({
      school_id: this.currentUser.school_id,
      location_id: id,
    })
      .then((response) => {
        this.FlashService.setMessage({
          type: "success",
          message: response.message,
        });
        this.fetchLocations();
      })
      .catch(() => {
        this.busy = false;
      });
  }

  toggleHiddenPickUpLocation(location) {
    this.busy = true;
    const data = Object.assign({}, location);
    data.hidden = !data.hidden;
    this.SchoolsModel.updateAdhocPickupLocation(
      this.currentUser.school_id,
      location.id,
      data,
    )
      .then((response) => {
        this.busy = false;
        this.FlashService.setMessage({
          type: "success",
          message: response.message,
        });
        location.hidden = data.hidden;
      })
      .catch((Error) => {
        this.busy = false;
      });
  }

  editLocation(location) {
    location._draft = {
      name: location.name,
      street: location.address ? location.address.street : "",
      city: location.address ? location.address.city : "",
      state: location.address ? location.address.state : "",
      zip: location.address ? String(location.address.zip || "") : "",
    };
    location._editing = true;
  }

  cancelEdit(location) {
    location._editing = false;
    delete location._draft;
  }

  saveLocation(location) {
    const draft = location._draft;
    this.busy = true;
    this.SchoolsModel.updateAdhocPickupLocation(
      this.currentUser.school_id,
      location.id,
      {
        name: draft.name,
        address: {
          street: draft.street,
          city: draft.city,
          state: draft.state,
          zip: draft.zip,
        },
      },
    )
      .then((response) => {
        this.busy = false;
        this.FlashService.setMessage({
          type: "success",
          message: response.message,
        });
        const updated = this.parseAddressJson(response.location);
        location.name = updated.name;
        location.address = updated.address;
        location._editing = false;
        delete location._draft;
      })
      .catch(() => {
        this.busy = false;
      });
  }
}

AdhocPickupLocations.$inject = [
  "$rootScope",
  "$state",
  "$stateParams",
  "SchoolsModel",
  "UsersModel",
  "FlashService",
  "UserService",
  "PoliciesModel",
  "PolicyData",
];
export default AdhocPickupLocations;
